import { useSetAtom } from 'jotai';
import useWebSocket from 'react-use-websocket';

import { ApiConfig } from '@data';

import { dispatchLiveFeedbackAtom } from './state/atoms';

export const LiveAnalysisListener = () => {
    const dispatch = useSetAtom(dispatchLiveFeedbackAtom);
    useWebSocket(ApiConfig.wsPath('/api/v1/live-feedback/ws'), {
        onMessage: (event: MessageEvent) => {
            try {
                const payload = JSON.parse(event.data);
                dispatch(payload);
            } catch (err) {
                console.error('Failed to parse live analysis payload:', event.data, err);
            }
        },
        shouldReconnect: () => true,
        reconnectAttempts: 1000,
        reconnectInterval: 2000,
    });

    return null;
};
